<script lang="ts">
  import { router } from './lib/router.svelte.ts';
  import Kopfleiste from './lib/Kopfleiste.svelte';
  import Fusszeile from './lib/Fusszeile.svelte';
  import Start from './seiten/Start.svelte';
  import Impressum from './seiten/Impressum.svelte';
  import Datenschutz from './seiten/Datenschutz.svelte';
  import Agb from './seiten/Agb.svelte';
  import Entgelte from './seiten/Entgelte.svelte';
  import Widerruf from './seiten/Widerruf.svelte';
  import BesondereBedingungen from './seiten/BesondereBedingungen.svelte';
  import Fernwartung from './seiten/Fernwartung.svelte';
  import Downloads from './seiten/Downloads.svelte';

  const pfad = $derived(router.pfad);
</script>

<Kopfleiste />

{#if pfad === '/'}
  <Start />
{:else if pfad === '/impressum'}
  <Impressum />
{:else if pfad === '/datenschutz'}
  <Datenschutz />
{:else if pfad === '/agb'}
  <Agb />
{:else if pfad === '/entgelte'}
  <Entgelte />
{:else if pfad === '/widerruf'}
  <Widerruf />
{:else if pfad === '/besondere-bedingungen'}
  <BesondereBedingungen />
{:else if pfad === '/fernwartung'}
  <Fernwartung />
{:else if pfad === '/dl'}
  <Downloads />
{:else}
  <div class="rechtstext">
    <h1>Diese Seite gibt es nicht</h1>
    <p><a href="/">Zurück zur Startseite</a></p>
  </div>
{/if}

<Fusszeile />
